module.exports = __webpack_public_path__ + "img/section3_img1.efa01d7a.png";